import dispatchCustomEvent from "./dispatchCustomEvent";

export default function(message) {
  dispatchCustomEvent(document, "add-notification-to-queue", true, true, { message: message });
}
